import * as types from '../actions/profile/types';


const INITIAL_STATE = {};

export default function profileReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.GET_PROFILE:

      return action.payload.profile;

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/profileReducer.js